import { useQuery } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';
import type { Tarefa } from '../types';

interface TarefasFilter {
  empresa_id?: string;
  status?: string;
  apenas_pendentes?: boolean;
  com_sla_estouro?: boolean;
  limit?: number;
}

export function useTarefas(filter: TarefasFilter = {}) {
  const params = new URLSearchParams();
  if (filter.empresa_id) params.set('empresa_id', filter.empresa_id);
  if (filter.status) params.set('status', filter.status);
  if (filter.apenas_pendentes) params.set('apenas_pendentes', 'true');
  if (filter.com_sla_estouro) params.set('com_sla_estouro', 'true');
  if (filter.limit) params.set('limit', String(filter.limit));
  const qs = params.toString();
  return useQuery({
    queryKey: ['tarefas', filter],
    queryFn: () => n8nFetch<Tarefa[]>(`/tarefas${qs ? `?${qs}` : ''}`),
  });
}
